module.exports = __webpack_public_path__ + "static/media/icon_qiyehaomarenzheng.43ad592d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_qiyehaomarenzheng.svg
// module id = 487
// module chunks = 0